import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const MATOMO_URL = "//analytics.nelx.net/";
const SITE_ID = "3";

/**
 * Hook to initialize Matomo analytics and track page views on route changes.
 * Must be used inside a Router component.
 */
const useMatomo = () => {
  const location = useLocation();

  // Initialize Matomo tracker (once)
  useEffect(() => {
    const _paq = (window._paq = window._paq || []);
    _paq.push(["enableLinkTracking"]);
    _paq.push(["setTrackerUrl", MATOMO_URL + "matomo.php"]);
    _paq.push(["setSiteId", SITE_ID]);

    // Load matomo.js script
    const script = document.createElement("script");
    script.async = true;
    script.src = MATOMO_URL + "matomo.js";
    document.head.appendChild(script);

    return () => {
      // Cleanup on unmount
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  // Track page view on every route change
  useEffect(() => {
    const _paq = (window._paq = window._paq || []);
    _paq.push(["setCustomUrl", window.location.href]);
    _paq.push(["setDocumentTitle", document.title]);
    _paq.push(["trackPageView"]);
  }, [location]);
};

export default useMatomo;
